import type { ApiError } from '@hedgehog/shared'

export class ApiRequestError extends Error {
  constructor(
    readonly status: number,
    readonly code: string | undefined,
    message: string,
  ) {
    super(message)
  }
}

/** Calls /api/v1<path> with the session cookie. Throws ApiRequestError with the server's message on non-2xx. */
export async function api<T>(path: string, init: RequestInit & { json?: unknown } = {}): Promise<T> {
  const { json, headers, ...rest } = init
  const res = await fetch(`/api/v1${path}`, {
    credentials: 'same-origin',
    ...rest,
    headers: { ...(json !== undefined ? { 'content-type': 'application/json' } : {}), ...headers },
    body: json !== undefined ? JSON.stringify(json) : rest.body,
  })
  if (res.status === 204) return undefined as T
  const body: unknown = await res.json().catch(() => null)
  if (!res.ok) {
    const err = (body ?? {}) as Partial<ApiError>
    throw new ApiRequestError(res.status, err.code, err.error ?? `Request failed (${res.status})`)
  }
  return body as T
}

export { formatPrice } from '@hedgehog/shared'
